import Storage from '@/helpers/storage'

export default {

    saveTracking: function (utms) {

        const utmSource = getValue(utms, 'utm_source') || 'organic'

        Storage.setItem('utm_source', utmSource)

        if (utms.utm_campaign) {
            Storage.setItem('utm_campaign', getValue(utms, 'utm_campaign'))
        }
        if (utms.utm_medium) {
            Storage.setItem('utm_medium', getValue(utms, 'utm_medium'))
        }
        if (utms.cid) {
            Storage.setItem('cid', getValue(utms, 'cid'))
        }

        Storage.setItem('referrer', getValue(utms, 'fox_referrer') || document.referrer || document.referer)
    },

    getTracking: function () {

        const utms = {}

        const source = Storage.getItem('utm_source')
        const campaign = Storage.getItem('utm_campaign')
        const medium = Storage.getItem('utm_medium')
        const referrer = Storage.getItem('referrer')
        const cid = Storage.getItem('cid')

        if (source) {
            utms['utm_source'] = source
        }
        if (campaign) {
            utms['utm_campaign'] = campaign
        }
        if (medium) {
            utms['utm_medium'] = medium
        }
        if (referrer) {
            utms['referrer'] = referrer
        }
        if (cid) {
            utms['cid'] = cid
        }

        return utms
    },

    getTrackingToQuery: function () {

        const tracking = this.getTracking()

        let str = ''

        for(const proprety in tracking) {

            if(tracking[proprety] && tracking[proprety] !== 'undefined') {

                str = `${ str }${ str.length ? '&' : '' }${ proprety }=${ tracking[proprety] }`

            }

        }

        return str


    }
}

function getValue (obj, key) {

    let value = obj[key]

    if (Array.isArray(value)) {

        value = value[0]
    }

    return value
}
